<ng-container>
  @if (containsLevel) {
    <div class="card-body">
      <ol class="stepper-list m-0 p-0" data-test-id="risk-score-levels">
        @for (step of steps; track $index; let i = $index) {
          <li
            class="stepper-list-item flex-fill"
            [class.active]="isActive(step)"
            [ngClass]="step.class"
            [attr.data-test-id]="isActive(step) ? 'risk-score-level' : null"
            [attr.aria-current]="isActive(step) ? 'true' : null"
          >
            <div aria-hidden="true" class="stepper-bar stepper-bar-vertical"></div>
            <span class="step-text mb-0">{{ step.label }}</span>
            <div aria-hidden="true" class="stepper-bar stepper-bar-horizontal"></div>
          </li>
        }
      </ol>
      <ds-link
        class="p-0 mt-2"
        standalone="true"
        href="#risk-score-explanation"
        data-test-id="risk-score-explanation-link"
        (click)="openRiskScoreExplanationModal($event)"
        >{{ 'how_is_this_status_calculated' | translate }}</ds-link
      >
    </div>
  }
  @if (!containsLevel) {
    <h3 class="h1 d-inline-block me-4" data-test-id="risk-score-level">{{ 'no_status_yet' | translate }}</h3>
  }
</ng-container>
